import { Drawer } from "antd";
import { createGlobalStyle } from "styled-components";
import { PortalHeader } from "../../../../../components/molecules/Header";
import { portalDrawerAntHeaderCss } from "../../../../../components/molecules/Header/Header.styles";

const CreateViewDrawerTheme = createGlobalStyle`
  .create-view-drawer .ant-drawer-content {
    background: #fff;
    border-left: 1px solid var(--PEARL, #ecf1f4);
    color: var(--GREY, #4a4a68);
    font-family: Inter, sans-serif;
  }
  .create-view-drawer .ant-drawer-header {
    ${portalDrawerAntHeaderCss}
  }
  .create-view-drawer .ant-drawer-title {
    font-family: inherit;
    width: 100%;
  }
  .create-view-drawer .ant-drawer-body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
`;

export function CreateViewDrawer({ isOpen, title, supplementary, onClose, children }) {
  return (
    <>
      <CreateViewDrawerTheme />
      <Drawer
        open={isOpen}
        title={<PortalHeader title={title} supplementary={supplementary} onClose={onClose} />}
        rootClassName="create-view-drawer"
        placement="right"
        width="min(960px, calc(100vw - 32px))"
        styles={{
          header: { padding: 0 },
          body: { padding: 0, overflow: "hidden", display: "flex", flexDirection: "column" },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.3)", backdropFilter: "blur(1px)" },
        }}
        onClose={onClose}
        closable={false}
        maskClosable={false}
        keyboard
        destroyOnClose
      >
        {children}
      </Drawer>
    </>
  );
}
